export default __webpack_public_path__ + "static/media/Pharo.c88d0591.png";